import React from 'react';
import PropTypes from 'prop-types';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMOwnerResource from 'resources/SMOwnerResource';
import SMDashboardBaseView from 'components/dashboard/shared/SMDashboardBaseView';
import Clipboard from 'clipboard';

class SMOReservationInviteView extends SMDashboardBaseView {

  componentDidMount() {
    this.clipboard = new Clipboard('.copy');
    this.clipboard.on('success', function(e) {
      e.clearSelection();
    });
  }

  componentWillUnmount() {
    this.clipboard.destroy();
    this.clipboard = null;
  }

  trackPageEvent(label) {
    SMTrackHelper.pageEvent(label);
  }

  formDidHide(e) {
    e.preventDefault();
    $(document).trigger("SMHideDialog");
  }

  linkDidClick(e) {
    e.preventDefault();
    if (e.currentTarget.name == 'close') {
      this.formDidHide(e);
    }
  }

  formDidSubmit(e){
    e.preventDefault();
    this.trackPageEvent('od sumit invite_reservation');
    let formData = new FormData(e.currentTarget);
    $(this.refs.form).startLoading();
    SMOwnerResource.confirm(this.props.reservation, formData, (data, error, xhr)=>{
      $(this.refs.form).stopLoading();
      if (!error) {
        if(this.props.delegate && typeof this.props.delegate.reservationDidConfirm === 'function'){
          this.props.delegate.reservationDidConfirm(data, xhr);
        }
      } else {
        if(this.props.delegate && typeof this.props.delegate.reservationDidFailToConfirm === 'function'){
          this.props.delegate.reservationDidFailToConfirm(error, xhr);
        }
      }
    });
  }

  render() {
    let reservation = this.props.reservation;
    let link = location.protocol + '//' + location.host + '/invitations/' + reservation.uid;
    let mailLink = 'mailto:?body=' + link;

    return (
      <div className="form-casette maincol-lightbox__form">
        <form onSubmit={this.formDidSubmit.bind(this)}>
          <h2 className="dashboard-title mb20">{I18n.t("dashboard.text_000601")}
            <span className="dashboard-title__supplement mr15">{I18n.t('dashboard.text_000602')}</span>
          </h2>
          <div className="form-box ta-c">
            <p className="mt20 mb30">
              <input
                type="text"
                name='invite_url'
                className="form-text w500 mr10 copy-target"
                value={link}
                readOnly={true}
                onClick={this.textFieldDidClick.bind(this)}
              />
          </p>
            <a href={mailLink}>
              <input className="button-blue pt10 pb10 w200 mr5" type="button" value={I18n.t('dashboard.label_000602')} />
            </a>
            <input className="copy button-blue pt10 pb10 w200 ml5" type="button" value={I18n.t('dashboard.label_000603')} data-clipboard-target=".copy-target" />
          </div>
          <a href="#" name="close" className="form-casette__close" onClick={this.linkDidClick.bind(this)}><i className="fa fa-times"></i></a>
        </form>
      </div>
    );
  }
}
SMOReservationInviteView.propTypes = {
  delegate: PropTypes.object,
  reservation: PropTypes.object.isRequired
};
export default SMOReservationInviteView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/reservations/SMOReservationInviteView.jsx